import { render } from "./WhyChooseUsLanguageDropdown.vue?vue&type=template&id=5fec3ec0&scoped=true"
import script from "./WhyChooseUsLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./WhyChooseUsLanguageDropdown.vue?vue&type=script&lang=js"

import "./WhyChooseUsLanguageDropdown.vue?vue&type=style&index=0&id=5fec3ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fec3ec0"]])

export default __exports__